import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'

@Component({
  selector: 'app-trip-listing-wizard-step3',
  templateUrl: './trip-listing-wizard-step3.component.html',
  styleUrls: ['./trip-listing-wizard-step3.component.scss'],
})
export class TripListingWizardStep3Component implements OnInit {
  @Output() prev = new EventEmitter()
  @Output() done = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
